import React from 'react';
import TablaVotosPartidos from './TablaVotosPartidos';

const DatosCamara_VotosPartidos = ({data, title}) => {
  return (
    <article className="votosAPartidos">
      <div className="subHeader">{title}</div>
      <div className="content">
        <TablaVotosPartidos
          data={data}
        />
      </div>
    </article>
  );
};

export default DatosCamara_VotosPartidos;
